import { CenteredShell, ShellHeading } from '../marketing/centered-shell';

/**
 * The extension flow's last screen. The tab exists only to hand the session
 * over, and the extension closes it — this says so in case the extension is
 * gone and nobody closes anything.
 */
export function ExtensionSignedIn() {
  return (
    <CenteredShell>
      <ShellHeading sub="Handing your session to the extension. You can close this tab.">
        Signed in
      </ShellHeading>
    </CenteredShell>
  );
}
